import React from 'react';
import Select, { components } from 'react-select';

class DropdownComponent extends React.Component {
  handleChange = (e) => {
    const { data, selectProps } = this.props;
    selectProps.onNoteChange(data.value, e.target.value);
  };
  handleIdChange = (e) => {
    const { data, selectProps } = this.props;
    selectProps.onClientIdChange(data.value, e.target.value);
  };
  handleSecretChange = (e) => {
    const { data, selectProps } = this.props;
    selectProps.onClientSecretChange(data.value, e.target.value);
  };
  render() {
    const { data } = this.props;
    return (
      <components.MultiValue {...this.props}>
        {data.label}
        <input
          style={{ marginLeft: 6, fontSize: 12 }} placeholder="Enter CIID"
          value={data.note || ''} onChange={this.handleChange} />
        <input
          style={{ marginLeft: 6, fontSize: 12 }} placeholder="Enter XAPIClientId"
          value={data.clientId || ''} onChange={this.handleIdChange} />
        <input
          style={{ marginLeft: 6, fontSize: 12 }} placeholder="Enter XAPISecretKey"
          value={data.clientSecretKey || ''} onChange={this.handleSecretChange} />
      </components.MultiValue>
    );
  }
}

export default class ProviderSubscriptionSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.initializeSelected(props.defaultValue || []),
      showPrompt: false,
      itemToRemove: null,
    };
  }
  confirmRemove = (confirm) => {
    if (confirm && this.state.itemToRemove) {
      const updated = this.state.selected.filter(
        (s) => s.value !== this.state.itemToRemove.value
      );
      this.setState({ selected: updated, showPrompt: false, itemToRemove: null });
      if (this.props.onChange) {
        this.props.onChange(updated);
      }
    } else {
      this.setState({ showPrompt: false, itemToRemove: null });
    }
  };
  initializeSelected = (input) => {
    return (input || []).map((item) => ({
      ...item,
      note: item.note || '',
      clientId: item.clientId || '',
      clientSecretKey: item.clientSecretKey || '',
    }));
  };
  handleRemove = (item) => {
    this.setState({ showPrompt: true, itemToRemove: item });
  };
  
  handleChange = (selected, actionMeta) => {
    if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
      const item = actionMeta.removedValue;
      this.handleRemove(item);
      return;
    }
    const updated = (selected || []).map((item) => {
      const existing = this.state.selected.find((s) => s.value === item.value);
      return { ...item, note: existing?.note, clientId: existing?.clientId, clientSecretKey: existing?.clientSecretKey || '' };
    });
    
    this.setState({ selected: updated });
      if (this.props.onChange) {
        this.props.onChange(updated);
      }
  };

  renderPrompt() {
    if (!this.state.showPrompt) return null;
    return (
      <div className="prompt">
        <p>Are you sure you want to remove this item?</p>
        <button onClick={() => this.confirmRemove(true)}>Yes</button>
        <button onClick={() => this.confirmRemove(false)}>No</button>
      </div>
    );
  }
  
  
  handleNoteChange = (value, note) => {
    const updated = this.state.selected.map((item) =>
      item.value === value ? { ...item, note } : item
    );
    this.setState({ selected: updated });
    if (this.props.onChange) {
      this.props.onChange(updated);
    }
  };
  
  handleClientIdChange = (value, clientId) => {
    const updated = this.state.selected.map((item) =>
      item.value === value ? { ...item, clientId } : item
    );
    this.setState({ selected: updated });
    if (this.props.onChange) {
      this.props.onChange(updated);
    }
  };
  handleClientSecretKeyChange = (value, clientSecretKey) => {
    const updated = this.state.selected.map((item) =>
      item.value === value ? { ...item, clientSecretKey } : item
    );
    this.setState({ selected: updated });
    if (this.props.onChange) {
      this.props.onChange(updated);
    }
  };

  render() {
    return (
    <div>
      <Select
        isMulti
        placeholder="Select Provider Subscription"
        value={this.state.selected}
        options={this.props.options || []}
        backspaceRemovesValue={false} // disables removing values with Backspace
        deleteRemovesValue={false}    // disables removing values with Delete
        onChange={this.handleChange}
        onNoteChange={this.handleNoteChange}
        onClientIdChange={this.handleClientIdChange}
        onClientSecretChange={this.handleClientSecretKeyChange}
        components={{ MultiValue: DropdownComponent }}
      />
      {this.renderPrompt()}
    </div>
    );
  }
}
